import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_SG_UQ || "uq.sg.new-styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_SG_UQ || 27402,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_SG_UQ || 27403,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_SG_UQ || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_SG_UQ || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_SG_UQ || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_SG_UQ || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: false,
  languages: [LANGUAGE.EN],
  countryRegion: "Asia/Singapore",
  timeZone: {
    [LANGUAGE.EN]: {
      defaultTimezone: "SGT",
      offset: {
        SGT: 8
      }
    }
  },
  dateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>/<yyyy>"
  },
  requireDecimal: false
};

export default _countryEnv;
